<template>
  <page>
    <div class="filters desktop" v-loading="loading.dashboard">
      <el-form inline size="small">
        <el-form-item>
          <el-date-picker
            v-model="datesRange"
            type="daterange"
            unlink-panels
            clearable
            start-placeholder="Start date"
            end-placeholder="End date"
            :format="dateRangeFormat"
            :picker-options="datePickerOptions"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="period" placeholder="Period">
            <el-option
              v-for="p in dashboardPeriodOptions"
              :key="p.value"
              :label="p.label"
              :value="p.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button
          @click="() => (showManageReportsDialog = true)"
          round
          icon="el-icon-s-tools"
          size="small"
          >Manage Dashboard</el-button
        >
      </div>
    </div>
    <div class="filters mobile" v-loading="loading.dashboard">
      <div>Filter results for the past:</div>
      <div>
        <el-button type="text" @click="updateResults(14, 'days', 'day')"
          >14 days</el-button
        >
        <el-button type="text" @click="updateResults(30, 'days', 'week')"
          >30 days</el-button
        >
        <el-button type="text" @click="updateResults(6, 'months', 'month')"
          >6 months</el-button
        >
      </div>
    </div>

    <div
      v-if="dashboard.reports && !dashboard.reports.length"
      style="text-align: center"
    >
      it seems like you don't follow any report... click on Manage dashboard in
      order to add some.
    </div>

    <div v-for="(report, index) in dashboard.reports" :key="index">
      <report-chart :report="report" :params="chartParams" />
    </div>

    <manage-reports
      :isOpen="showManageReportsDialog"
      :onClose="() => (showManageReportsDialog = false)"
    />
  </page>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

import Page from "@/components/layout/Page";
import ReportChart from "@/views/Product/Reports/ReportChart";
import ManageReports from "./Reports/ManageDashboardDialog";
import { dashboardPeriodOptions, datePickerOptions } from "./constants";

export default {
  data() {
    const start = moment().subtract(1, "month").toDate();
    const end = moment().subtract(1, "day").toDate();
    return {
      datesRange: [start, end],
      period: "week",
      results: [],
      dashboardPeriodOptions,
      datePickerOptions,
      showManageReportsDialog: false,
      dateRangeType: "date",
      dateRangeFormat: "d MMM, yyyy",
      chartParams: {},
    };
  },
  components: {
    Page,
    ReportChart,
    ManageReports,
  },
  async mounted() {
    await this.getDashboard();
  },
  computed: mapGetters(["dashboard", "loading"]),
  methods: {
    ...mapActions(["getDashboard"]),
    updateResults(time, unit, newPeriod) {
      const start = moment().subtract(time, unit);
      const end = moment().subtract(1, "day");
      this.datesRange = [start.toDate(), end.toDate()];
      this.period = newPeriod;
    },
  },
  watch: {
    datesRange: {
      deep: true,
      handler() {
        const {
          datesRange: [start, end],
          period,
        } = this;
        this.chartParams = { start, end, period };
      },
    },
    period(newPeriod) {
      const {
        datesRange: [start, end],
      } = this;
      this.chartParams = { start, end, period: newPeriod };
      switch (newPeriod) {
        case "year":
          this.dateRangeFormat = "yyyy";
          break;
        case "month":
          this.dateRangeFormat = "MMMM yyyy";
          break;
        default:
          this.dateRangeFormat = "d MMM, yyyy";
          break;
      }
    },
  },
};
</script>

<style scoped>
.filters {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.collapse-button {
  cursor: pointer;
}
.mobile {
  display: none;
}

@media screen and (max-width: 600px) {
  .filters {
    flex-direction: column;
    max-width: 100%;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
